const fiat = [
  {
    state: 'Abkhazia',
    currency: 'Abkhazian apsar',
    symbol: null,
    ISO_code: null,
    fractional_unit: null,
    number_to_basic: null,
  },
  {
    state: 'Afghanistan',
    currency: 'Afghan afghani',
    symbol: '؋',
    ISO_code: 'AFN',
    fractional_unit: 'Pul',
    number_to_basic: 100,
  },
  {
    state: 'Akrotiri and Dhekelia',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Albania',
    currency: 'Albanian lek',
    symbol: 'L',
    ISO_code: 'ALL',
    fractional_unit: 'Qindarkë',
    number_to_basic: 100,
  },
  {
    state: 'Alderney',
    currency: 'Alderney pound',
    symbol: '£',
    ISO_code: null,
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Algeria',
    currency: 'Algerian dinar',
    symbol: 'د.ج',
    ISO_code: 'DZD',
    fractional_unit: 'Santeem',
    number_to_basic: 100,
  },
  {
    state: 'Andorra',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Angola',
    currency: 'Angolan kwanza',
    symbol: 'Kz',
    ISO_code: 'AOA',
    fractional_unit: 'Cêntimo',
    number_to_basic: 100,
  },
  {
    state: 'Anguilla',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Antigua and Barbuda',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Argentina',
    currency: 'Argentine peso',
    symbol: '$',
    ISO_code: 'ARS',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Armenia',
    currency: 'Armenian dram',
    symbol: '֏',
    ISO_code: 'AMD',
    fractional_unit: 'Luma',
    number_to_basic: 100,
  },
  {
    state: 'Artsakh',
    currency: 'Artsakh dram',
    symbol: 'դր.',
    ISO_code: null,
    fractional_unit: 'Luma',
    number_to_basic: 100,
  },
  {
    state: 'Aruba',
    currency: 'Aruban florin',
    symbol: 'ƒ',
    ISO_code: 'AWG',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Ascension Island',
    currency: 'Saint Helena pound',
    symbol: '£',
    ISO_code: 'SHP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Australia',
    currency: 'Australian dollar',
    symbol: '$',
    ISO_code: 'AUD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Austria',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Azerbaijan',
    currency: 'Azerbaijani manat',
    symbol: '₼',
    ISO_code: 'AZN',
    fractional_unit: 'Qəpik',
    number_to_basic: 100,
  },
  {
    state: 'Bahamas',
    currency: 'Bahamian dollar',
    symbol: '$',
    ISO_code: 'BSD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Bahrain',
    currency: 'Bahraini dinar',
    symbol: '.د.ب',
    ISO_code: 'BHD',
    fractional_unit: 'Fils',
    number_to_basic: 1000,
  },
  {
    state: 'Bangladesh',
    currency: 'Bangladeshi taka',
    symbol: '৳',
    ISO_code: 'BDT',
    fractional_unit: 'Poisha',
    number_to_basic: 100,
  },
  {
    state: 'Barbados',
    currency: 'Barbadian dollar',
    symbol: '$',
    ISO_code: 'BBD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Belarus',
    currency: 'Belarusian ruble',
    symbol: 'Br',
    ISO_code: 'BYN',
    fractional_unit: 'Kapyeyka',
    number_to_basic: 100,
  },
  {
    state: 'Belgium',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Belize',
    currency: 'Belize dollar',
    symbol: '$',
    ISO_code: 'BZD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Benin',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Bermuda',
    currency: 'Bermudian dollar',
    symbol: '$',
    ISO_code: 'BMD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Bhutan',
    currency: 'Bhutanese ngultrum',
    symbol: 'Nu.',
    ISO_code: 'BTN',
    fractional_unit: 'Chetrum',
    number_to_basic: 100,
  },
  {
    state: 'Bolivia',
    currency: 'Bolivian boliviano',
    symbol: 'Bs.',
    ISO_code: 'BOB',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Bonaire',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Bosnia and Herzegovina',
    currency: 'Bosnia and Herzegovina convertible mark',
    symbol: 'KM',
    ISO_code: 'BAM',
    fractional_unit: 'Fening',
    number_to_basic: 100,
  },
  {
    state: 'Botswana',
    currency: 'Botswana pula',
    symbol: 'P',
    ISO_code: 'BWP',
    fractional_unit: 'Thebe',
    number_to_basic: 100,
  },
  {
    state: 'Brazil',
    currency: 'Brazilian real',
    symbol: 'R$',
    ISO_code: 'BRL',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'British Indian Ocean Territory',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'British Virgin Islands',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Brunei',
    currency: 'Brunei dollar',
    symbol: '$',
    ISO_code: 'BND',
    fractional_unit: 'Sen',
    number_to_basic: 100,
  },
  {
    state: 'Bulgaria',
    currency: 'Bulgarian lev',
    symbol: 'лв.',
    ISO_code: 'BGN',
    fractional_unit: 'Stotinka',
    number_to_basic: 100,
  },
  {
    state: 'Burkina Faso',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Burundi',
    currency: 'Burundian franc',
    symbol: 'Fr',
    ISO_code: 'BIF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Cambodia',
    currency: 'Cambodian riel',
    symbol: '៛',
    ISO_code: 'KHR',
    fractional_unit: 'Sen',
    number_to_basic: 100,
  },
  {
    state: 'Cameroon',
    currency: 'Central African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XAF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Canada',
    currency: 'Canadian dollar',
    symbol: '$',
    ISO_code: 'CAD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Cape Verde',
    currency: 'Cape Verdean escudo',
    symbol: 'Esc',
    ISO_code: 'CVE',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Cayman Islands',
    currency: 'Cayman Islands dollar',
    symbol: '$',
    ISO_code: 'KYD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Central African Republic',
    currency: 'Central African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XAF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Chad',
    currency: 'Central African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XAF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Chile',
    currency: 'Chilean peso',
    symbol: '$',
    ISO_code: 'CLP',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'China',
    currency: 'Chinese yuan',
    symbol: '¥',
    ISO_code: 'CNY',
    fractional_unit: 'Jiao',
    number_to_basic: 10,
  },
  {
    state: 'Colombia',
    currency: 'Colombian peso',
    symbol: '$',
    ISO_code: 'COP',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Comoros',
    currency: 'Comorian franc',
    symbol: 'Fr',
    ISO_code: 'KMF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Congo, Democratic Republic of the',
    currency: 'Congolese franc',
    symbol: 'Fr',
    ISO_code: 'CDF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Congo, Republic of the',
    currency: 'Central African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XAF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Cook Islands',
    currency: 'Cook Islands dollar',
    symbol: '$',
    ISO_code: 'CKD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Costa Rica',
    currency: 'Costa Rican colón',
    symbol: '₡',
    ISO_code: 'CRC',
    fractional_unit: 'Céntimo',
    number_to_basic: 100,
  },
  {
    state: "Côte d'Ivoire",
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Croatia',
    currency: 'Croatian kuna',
    symbol: 'kn',
    ISO_code: 'HRK',
    fractional_unit: 'Lipa',
    number_to_basic: 100,
  },
  {
    state: 'Cuba',
    currency: 'Cuban peso',
    symbol: '$',
    ISO_code: 'CUP',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Curaçao',
    currency: 'Netherlands Antillean guilder',
    symbol: 'ƒ',
    ISO_code: 'ANG',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Cyprus',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Czech Republic',
    currency: 'Czech koruna',
    symbol: 'Kč',
    ISO_code: 'CZK',
    fractional_unit: 'Haléř',
    number_to_basic: 100,
  },
  {
    state: 'Denmark',
    currency: 'Danish krone',
    symbol: 'kr',
    ISO_code: 'DKK',
    fractional_unit: 'Øre',
    number_to_basic: 100,
  },
  {
    state: 'Djibouti',
    currency: 'Djiboutian franc',
    symbol: 'Fr',
    ISO_code: 'DJF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Dominica',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Dominican Republic',
    currency: 'Dominican peso',
    symbol: '$',
    ISO_code: 'DOP',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'East Timor',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Ecuador',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Egypt',
    currency: 'Egyptian pound',
    symbol: '£',
    ISO_code: 'EGP',
    fractional_unit: 'Piastre',
    number_to_basic: 100,
  },
  {
    state: 'El Salvador',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Equatorial Guinea',
    currency: 'Central African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XAF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Eritrea',
    currency: 'Eritrean nakfa',
    symbol: 'Nfk',
    ISO_code: 'ERN',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Estonia',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Eswatini',
    currency: 'Swazi lilangeni',
    symbol: 'L',
    ISO_code: 'SZL',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Ethiopia',
    currency: 'Ethiopian birr',
    symbol: 'Br',
    ISO_code: 'ETB',
    fractional_unit: 'Santim',
    number_to_basic: 100,
  },
  {
    state: 'Falkland Islands',
    currency: 'Falkland Islands pound',
    symbol: '£',
    ISO_code: 'FKP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Faroe Islands',
    currency: 'Danish krone',
    symbol: 'kr',
    ISO_code: 'DKK',
    fractional_unit: 'Øre',
    number_to_basic: 100,
  },
  {
    state: 'Fiji',
    currency: 'Fijian dollar',
    symbol: '$',
    ISO_code: 'FJD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Finland',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'France',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'French Polynesia',
    currency: 'CFP franc',
    symbol: '₣',
    ISO_code: 'XPF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Gabon',
    currency: 'Central African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XAF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Gambia',
    currency: 'Gambian dalasi',
    symbol: 'D',
    ISO_code: 'GMD',
    fractional_unit: 'Butut',
    number_to_basic: 100,
  },
  {
    state: 'Georgia',
    currency: 'Georgian lari',
    symbol: 'ლ',
    ISO_code: 'GEL',
    fractional_unit: 'Tetri',
    number_to_basic: 100,
  },
  {
    state: 'Germany',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Ghana',
    currency: 'Ghanaian cedi',
    symbol: '₵',
    ISO_code: 'GHS',
    fractional_unit: 'Pesewa',
    number_to_basic: 100,
  },
  {
    state: 'Gibraltar',
    currency: 'Gibraltar pound',
    symbol: '£',
    ISO_code: 'GIP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Greece',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Grenada',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Guatemala',
    currency: 'Guatemalan quetzal',
    symbol: 'Q',
    ISO_code: 'GTQ',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Guernsey',
    currency: 'Guernsey pound',
    symbol: '£',
    ISO_code: 'GGP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Guinea',
    currency: 'Guinean franc',
    symbol: 'Fr',
    ISO_code: 'GNF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Guinea-Bissau',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Guyana',
    currency: 'Guyanese dollar',
    symbol: '$',
    ISO_code: 'GYD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Haiti',
    currency: 'Haitian gourde',
    symbol: 'G',
    ISO_code: 'HTG',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Honduras',
    currency: 'Honduran lempira',
    symbol: 'L',
    ISO_code: 'HNL',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Hong Kong',
    currency: 'Hong Kong dollar',
    symbol: '$',
    ISO_code: 'HKD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Hungary',
    currency: 'Hungarian forint',
    symbol: 'Ft',
    ISO_code: 'HUF',
    fractional_unit: 'Fillér',
    number_to_basic: 100,
  },
  {
    state: 'Iceland',
    currency: 'Icelandic króna',
    symbol: 'kr',
    ISO_code: 'ISK',
    fractional_unit: 'Eyrir',
    number_to_basic: 100,
  },
  {
    state: 'India',
    currency: 'Indian rupee',
    symbol: '₹',
    ISO_code: 'INR',
    fractional_unit: 'Paisa',
    number_to_basic: 100,
  },
  {
    state: 'Indonesia',
    currency: 'Indonesian rupiah',
    symbol: 'Rp',
    ISO_code: 'IDR',
    fractional_unit: 'Sen',
    number_to_basic: 100,
  },
  {
    state: 'Iran',
    currency: 'Iranian rial',
    symbol: '﷼',
    ISO_code: 'IRR',
    fractional_unit: 'Dinar',
    number_to_basic: 100,
  },
  {
    state: 'Iraq',
    currency: 'Iraqi dinar',
    symbol: 'ع.د',
    ISO_code: 'IQD',
    fractional_unit: 'Fils',
    number_to_basic: 1000,
  },
  {
    state: 'Ireland',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Isle of Man',
    currency: 'Manx pound',
    symbol: '£',
    ISO_code: 'IMP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Israel',
    currency: 'Israeli new shekel',
    symbol: '₪',
    ISO_code: 'ILS',
    fractional_unit: 'Agora',
    number_to_basic: 100,
  },
  {
    state: 'Italy',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Jamaica',
    currency: 'Jamaican dollar',
    symbol: '$',
    ISO_code: 'JMD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Japan',
    currency: 'Japanese yen',
    symbol: '¥',
    ISO_code: 'JPY',
    fractional_unit: 'Sen',
    number_to_basic: 100,
  },
  {
    state: 'Jersey',
    currency: 'Jersey pound',
    symbol: '£',
    ISO_code: 'JEP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Jordan',
    currency: 'Jordanian dinar',
    symbol: 'د.ا',
    ISO_code: 'JOD',
    fractional_unit: 'Piastre',
    number_to_basic: 100,
  },
  {
    state: 'Kazakhstan',
    currency: 'Kazakhstani tenge',
    symbol: '₸',
    ISO_code: 'KZT',
    fractional_unit: 'Tıyn',
    number_to_basic: 100,
  },
  {
    state: 'Kenya',
    currency: 'Kenyan shilling',
    symbol: 'Sh',
    ISO_code: 'KES',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Kiribati',
    currency: 'Kiribati dollar',
    symbol: '$',
    ISO_code: 'KID',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Korea, North',
    currency: 'North Korean won',
    symbol: '₩',
    ISO_code: 'KPW',
    fractional_unit: 'Chon',
    number_to_basic: 100,
  },
  {
    state: 'Korea, South',
    currency: 'South Korean won',
    symbol: '₩',
    ISO_code: 'KRW',
    fractional_unit: 'Jeon',
    number_to_basic: 100,
  },
  {
    state: 'Kosovo',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Kuwait',
    currency: 'Kuwaiti dinar',
    symbol: 'د.ك',
    ISO_code: 'KWD',
    fractional_unit: 'Fils',
    number_to_basic: 1000,
  },
  {
    state: 'Kyrgyzstan',
    currency: 'Kyrgyzstani som',
    symbol: 'с',
    ISO_code: 'KGS',
    fractional_unit: 'Tyiyn',
    number_to_basic: 100,
  },
  {
    state: 'Laos',
    currency: 'Lao kip',
    symbol: '₭',
    ISO_code: 'LAK',
    fractional_unit: 'Att',
    number_to_basic: 100,
  },
  {
    state: 'Latvia',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Lebanon',
    currency: 'Lebanese pound',
    symbol: 'ل.ل',
    ISO_code: 'LBP',
    fractional_unit: 'Piastre',
    number_to_basic: 100,
  },
  {
    state: 'Lesotho',
    currency: 'Lesotho loti',
    symbol: 'L',
    ISO_code: 'LSL',
    fractional_unit: 'Sente',
    number_to_basic: 100,
  },
  {
    state: 'Liberia',
    currency: 'Liberian dollar',
    symbol: '$',
    ISO_code: 'LRD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Libya',
    currency: 'Libyan dinar',
    symbol: 'ل.د',
    ISO_code: 'LYD',
    fractional_unit: 'Dirham',
    number_to_basic: 1000,
  },
  {
    state: 'Liechtenstein',
    currency: 'Swiss franc',
    symbol: 'Fr.',
    ISO_code: 'CHF',
    fractional_unit: 'Rappen',
    number_to_basic: 100,
  },
  {
    state: 'Lithuania',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Luxembourg',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Macau',
    currency: 'Macanese pataca',
    symbol: 'P',
    ISO_code: 'MOP',
    fractional_unit: 'Avo',
    number_to_basic: 100,
  },
  {
    state: 'Madagascar',
    currency: 'Malagasy ariary',
    symbol: 'Ar',
    ISO_code: 'MGA',
    fractional_unit: 'Iraimbilanja',
    number_to_basic: 5,
  },
  {
    state: 'Malawi',
    currency: 'Malawian kwacha',
    symbol: 'MK',
    ISO_code: 'MWK',
    fractional_unit: 'Tambala',
    number_to_basic: 100,
  },
  {
    state: 'Malaysia',
    currency: 'Malaysian ringgit',
    symbol: 'RM',
    ISO_code: 'MYR',
    fractional_unit: 'Sen',
    number_to_basic: 100,
  },
  {
    state: 'Maldives',
    currency: 'Maldivian rufiyaa',
    symbol: '.ރ',
    ISO_code: 'MVR',
    fractional_unit: 'Laari',
    number_to_basic: 100,
  },
  {
    state: 'Mali',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Malta',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Marshall Islands',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Mauritania',
    currency: 'Mauritanian ouguiya',
    symbol: 'UM',
    ISO_code: 'MRU',
    fractional_unit: 'Khoums',
    number_to_basic: 5,
  },
  {
    state: 'Mauritius',
    currency: 'Mauritian rupee',
    symbol: '₨',
    ISO_code: 'MUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Mexico',
    currency: 'Mexican peso',
    symbol: '$',
    ISO_code: 'MXN',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Micronesia',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Moldova',
    currency: 'Moldovan leu',
    symbol: 'L',
    ISO_code: 'MDL',
    fractional_unit: 'Ban',
    number_to_basic: 100,
  },
  {
    state: 'Monaco',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Mongolia',
    currency: 'Mongolian tögrög',
    symbol: '₮',
    ISO_code: 'MNT',
    fractional_unit: 'Möngö',
    number_to_basic: 100,
  },
  {
    state: 'Montenegro',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Montserrat',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Morocco',
    currency: 'Moroccan dirham',
    symbol: 'د.م.',
    ISO_code: 'MAD',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Mozambique',
    currency: 'Mozambican metical',
    symbol: 'MT',
    ISO_code: 'MZN',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Myanmar',
    currency: 'Burmese kyat',
    symbol: 'Ks',
    ISO_code: 'MMK',
    fractional_unit: 'Pya',
    number_to_basic: 100,
  },
  {
    state: 'Namibia',
    currency: 'Namibian dollar',
    symbol: '$',
    ISO_code: 'NAD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Nauru',
    currency: 'Australian dollar',
    symbol: '$',
    ISO_code: 'AUD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Nepal',
    currency: 'Nepalese rupee',
    symbol: 'रू',
    ISO_code: 'NPR',
    fractional_unit: 'Paisa',
    number_to_basic: 100,
  },
  {
    state: 'Netherlands',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'New Caledonia',
    currency: 'CFP franc',
    symbol: '₣',
    ISO_code: 'XPF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'New Zealand',
    currency: 'New Zealand dollar',
    symbol: '$',
    ISO_code: 'NZD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Nicaragua',
    currency: 'Nicaraguan córdoba',
    symbol: 'C$',
    ISO_code: 'NIO',
    fractional_unit: 'Centavo',
    number_to_basic: 100,
  },
  {
    state: 'Niger',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Nigeria',
    currency: 'Nigerian naira',
    symbol: '₦',
    ISO_code: 'NGN',
    fractional_unit: 'Kobo',
    number_to_basic: 100,
  },
  {
    state: 'Niue',
    currency: 'New Zealand dollar',
    symbol: '$',
    ISO_code: 'NZD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'North Macedonia',
    currency: 'Macedonian denar',
    symbol: 'ден',
    ISO_code: 'MKD',
    fractional_unit: 'Deni',
    number_to_basic: 100,
  },
  {
    state: 'Northern Cyprus',
    currency: 'Turkish lira',
    symbol: '₺',
    ISO_code: 'TRY',
    fractional_unit: 'Kuruş',
    number_to_basic: 100,
  },
  {
    state: 'Norway',
    currency: 'Norwegian krone',
    symbol: 'kr',
    ISO_code: 'NOK',
    fractional_unit: 'Øre',
    number_to_basic: 100,
  },
  {
    state: 'Oman',
    currency: 'Omani rial',
    symbol: 'ر.ع.',
    ISO_code: 'OMR',
    fractional_unit: 'Baisa',
    number_to_basic: 1000,
  },
  {
    state: 'Pakistan',
    currency: 'Pakistani rupee',
    symbol: '₨',
    ISO_code: 'PKR',
    fractional_unit: 'Paisa',
    number_to_basic: 100,
  },
  {
    state: 'Palau',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Palestine',
    currency: 'Israeli new shekel',
    symbol: '₪',
    ISO_code: 'ILS',
    fractional_unit: 'Agora',
    number_to_basic: 100,
  },
  {
    state: 'Panama',
    currency: 'Panamanian balboa',
    symbol: 'B/.',
    ISO_code: 'PAB',
    fractional_unit: 'Centésimo',
    number_to_basic: 100,
  },
  {
    state: 'Papua New Guinea',
    currency: 'Papua New Guinean kina',
    symbol: 'K',
    ISO_code: 'PGK',
    fractional_unit: 'Toea',
    number_to_basic: 100,
  },
  {
    state: 'Paraguay',
    currency: 'Paraguayan guaraní',
    symbol: '₲',
    ISO_code: 'PYG',
    fractional_unit: 'Céntimo',
    number_to_basic: 100,
  },
  {
    state: 'Peru',
    currency: 'Peruvian sol',
    symbol: 'S/.',
    ISO_code: 'PEN',
    fractional_unit: 'Céntimo',
    number_to_basic: 100,
  },
  {
    state: 'Philippines',
    currency: 'Philippine peso',
    symbol: '₱',
    ISO_code: 'PHP',
    fractional_unit: 'Sentimo',
    number_to_basic: 100,
  },
  {
    state: 'Pitcairn Islands',
    currency: 'New Zealand dollar',
    symbol: '$',
    ISO_code: 'NZD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Poland',
    currency: 'Polish złoty',
    symbol: 'zł',
    ISO_code: 'PLN',
    fractional_unit: 'Grosz',
    number_to_basic: 100,
  },
  {
    state: 'Portugal',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Qatar',
    currency: 'Qatari riyal',
    symbol: 'ر.ق',
    ISO_code: 'QAR',
    fractional_unit: 'Dirham',
    number_to_basic: 100,
  },
  {
    state: 'Romania',
    currency: 'Romanian leu',
    symbol: 'lei',
    ISO_code: 'RON',
    fractional_unit: 'Ban',
    number_to_basic: 100,
  },
  {
    state: 'Russia',
    currency: 'Russian ruble',
    symbol: '₽',
    ISO_code: 'RUB',
    fractional_unit: 'Kopek',
    number_to_basic: 100,
  },
  {
    state: 'Rwanda',
    currency: 'Rwandan franc',
    symbol: 'Fr',
    ISO_code: 'RWF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Saba',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Sahrawi Republic',
    currency: 'Algerian dinar',
    symbol: 'د.ج',
    ISO_code: 'DZD',
    fractional_unit: 'Santeem',
    number_to_basic: 100,
  },
  {
    state: 'Saint Helena',
    currency: 'Saint Helena pound',
    symbol: '£',
    ISO_code: 'SHP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'Saint Kitts and Nevis',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Saint Lucia',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Saint Vincent and the Grenadines',
    currency: 'Eastern Caribbean dollar',
    symbol: '$',
    ISO_code: 'XCD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Samoa',
    currency: 'Samoan tālā',
    symbol: 'T',
    ISO_code: 'WST',
    fractional_unit: 'Sene',
    number_to_basic: 100,
  },
  {
    state: 'San Marino',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'São Tomé and Príncipe',
    currency: 'São Tomé and Príncipe dobra',
    symbol: 'Db',
    ISO_code: 'STN',
    fractional_unit: 'Cêntimo',
    number_to_basic: 100,
  },
  {
    state: 'Saudi Arabia',
    currency: 'Saudi riyal',
    symbol: '﷼‎',
    ISO_code: 'SAR',
    fractional_unit: 'Halala',
    number_to_basic: 100,
  },
  {
    state: 'Senegal',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Serbia',
    currency: 'Serbian dinar',
    symbol: 'дин.',
    ISO_code: 'RSD',
    fractional_unit: 'Para',
    number_to_basic: 100,
  },
  {
    state: 'Seychelles',
    currency: 'Seychellois rupee',
    symbol: '₨',
    ISO_code: 'SCR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Sierra Leone',
    currency: 'Sierra Leonean leone',
    symbol: 'Le',
    ISO_code: 'SLL',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Singapore',
    currency: 'Singapore dollar',
    symbol: '$',
    ISO_code: 'SGD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Sint Eustatius',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Sint Maarten',
    currency: 'Netherlands Antillean guilder',
    symbol: 'ƒ',
    ISO_code: 'ANG',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Slovakia',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Slovenia',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Solomon Islands',
    currency: 'Solomon Islands dollar',
    symbol: '$',
    ISO_code: 'SBD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Somalia',
    currency: 'Somali shilling',
    symbol: 'Sh',
    ISO_code: 'SOS',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Somaliland',
    currency: 'Somaliland shilling',
    symbol: 'Sl',
    ISO_code: 'SLS',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'South Africa',
    currency: 'South African rand',
    symbol: 'R',
    ISO_code: 'ZAR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'South Ossetia',
    currency: 'Russian ruble',
    symbol: '₽',
    ISO_code: 'RUB',
    fractional_unit: 'Kopek',
    number_to_basic: 100,
  },
  {
    state: 'Spain',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'South Sudan',
    currency: 'South Sudanese pound',
    symbol: '£',
    ISO_code: 'SSP',
    fractional_unit: 'Piaster',
    number_to_basic: 100,
  },
  {
    state: 'Sri Lanka',
    currency: 'Sri Lankan rupee',
    symbol: 'Rs',
    ISO_code: 'LKR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Sudan',
    currency: 'Sudanese pound',
    symbol: 'ج.س.',
    ISO_code: 'SDG',
    fractional_unit: 'Piastre',
    number_to_basic: 100,
  },
  {
    state: 'Suriname',
    currency: 'Surinamese dollar',
    symbol: '$',
    ISO_code: 'SRD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Sweden',
    currency: 'Swedish krona',
    symbol: 'kr',
    ISO_code: 'SEK',
    fractional_unit: 'Öre',
    number_to_basic: 100,
  },
  {
    state: 'Switzerland',
    currency: 'Swiss franc',
    symbol: 'Fr.',
    ISO_code: 'CHF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Syria',
    currency: 'Syrian pound',
    symbol: '£',
    ISO_code: 'SYP',
    fractional_unit: 'Piastre',
    number_to_basic: 100,
  },
  {
    state: 'Taiwan',
    currency: 'New Taiwan dollar',
    symbol: '$',
    ISO_code: 'TWD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Tajikistan',
    currency: 'Tajikistani somoni',
    symbol: 'ЅМ',
    ISO_code: 'TJS',
    fractional_unit: 'Diram',
    number_to_basic: 100,
  },
  {
    state: 'Tanzania',
    currency: 'Tanzanian shilling',
    symbol: 'Sh',
    ISO_code: 'TZS',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Thailand',
    currency: 'Thai baht',
    symbol: '฿',
    ISO_code: 'THB',
    fractional_unit: 'Satang',
    number_to_basic: 100,
  },
  {
    state: 'Togo',
    currency: 'West African CFA franc',
    symbol: 'Fr',
    ISO_code: 'XOF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Tonga',
    currency: 'Tongan paʻanga',
    symbol: 'T$',
    ISO_code: 'TOP',
    fractional_unit: 'Seniti',
    number_to_basic: 100,
  },
  {
    state: 'Transnistria',
    currency: 'Transnistrian ruble',
    symbol: 'р.',
    ISO_code: 'PRB',
    fractional_unit: 'Kopek',
    number_to_basic: 100,
  },
  {
    state: 'Trinidad and Tobago',
    currency: 'Trinidad and Tobago dollar',
    symbol: '$',
    ISO_code: 'TTD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Tunisia',
    currency: 'Tunisian dinar',
    symbol: 'د.ت',
    ISO_code: 'TND',
    fractional_unit: 'Millime',
    number_to_basic: 1000,
  },
  {
    state: 'Turkey',
    currency: 'Turkish lira',
    symbol: '₺',
    ISO_code: 'TRY',
    fractional_unit: 'Kuruş',
    number_to_basic: 100,
  },
  {
    state: 'Turkmenistan',
    currency: 'Turkmenistan manat',
    symbol: 'm',
    ISO_code: 'TMT',
    fractional_unit: 'Tennesi',
    number_to_basic: 100,
  },
  {
    state: 'Turks and Caicos Islands',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Tuvalu',
    currency: 'Tuvaluan dollar',
    symbol: '$',
    ISO_code: 'TVD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Uganda',
    currency: 'Ugandan shilling',
    symbol: 'Sh',
    ISO_code: 'UGX',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Ukraine',
    currency: 'Ukrainian hryvnia',
    symbol: '₴',
    ISO_code: 'UAH',
    fractional_unit: 'Kopiyka',
    number_to_basic: 100,
  },
  {
    state: 'United Arab Emirates',
    currency: 'United Arab Emirates dirham',
    symbol: 'د.إ',
    ISO_code: 'AED',
    fractional_unit: 'Fils',
    number_to_basic: 100,
  },
  {
    state: 'United Kingdom',
    currency: 'British pound',
    symbol: '£',
    ISO_code: 'GBP',
    fractional_unit: 'Penny',
    number_to_basic: 100,
  },
  {
    state: 'United States',
    currency: 'United States dollar',
    symbol: '$',
    ISO_code: 'USD',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Uruguay',
    currency: 'Uruguayan peso',
    symbol: '$',
    ISO_code: 'UYU',
    fractional_unit: 'Centésimo',
    number_to_basic: 100,
  },
  {
    state: 'Uzbekistan',
    currency: 'Uzbekistani soʻm',
    symbol: "so'm",
    ISO_code: 'UZS',
    fractional_unit: 'Tiyin',
    number_to_basic: 100,
  },
  {
    state: 'Vanuatu',
    currency: 'Vanuatu vatu',
    symbol: 'Vt',
    ISO_code: 'VUV',
    fractional_unit: null,
    number_to_basic: null,
  },
  {
    state: 'Vatican City',
    currency: 'Euro',
    symbol: '€',
    ISO_code: 'EUR',
    fractional_unit: 'Cent',
    number_to_basic: 100,
  },
  {
    state: 'Venezuela',
    currency: 'Venezuelan bolívar soberano',
    symbol: 'Bs.S.',
    ISO_code: 'VES',
    fractional_unit: 'Céntimo',
    number_to_basic: 100,
  },
  {
    state: 'Vietnam',
    currency: 'Vietnamese đồng',
    symbol: '₫',
    ISO_code: 'VND',
    fractional_unit: 'Hào',
    number_to_basic: 10,
  },
  {
    state: 'Wallis and Futuna',
    currency: 'CFP franc',
    symbol: '₣',
    ISO_code: 'XPF',
    fractional_unit: 'Centime',
    number_to_basic: 100,
  },
  {
    state: 'Yemen',
    currency: 'Yemeni rial',
    symbol: 'ر.ي',
    ISO_code: 'YER',
    fractional_unit: 'Fils',
    number_to_basic: 100,
  },
  {
    state: 'Zambia',
    currency: 'Zambian kwacha',
    symbol: 'ZK',
    ISO_code: 'ZMW',
    fractional_unit: 'Ngwee',
    number_to_basic: 100,
  },
  {
    state: 'Zimbabwe',
    currency: 'RTGS dollar',
    symbol: null,
    ISO_code: null,
    fractional_unit: null,
    number_to_basic: null,
  },
];

export default fiat;
